import { render, staticRenderFns } from "./KoreanCartNew.vue?vue&type=template&id=38b49fde&scoped=true"
import script from "./KoreanCartNew.vue?vue&type=script&lang=js"
export * from "./KoreanCartNew.vue?vue&type=script&lang=js"
import style0 from "./KoreanCartNew.vue?vue&type=style&index=0&id=38b49fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b49fde",
  null
  
)

export default component.exports